// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body * {
    visibility: hidden;
    font-family: 'Times New Roman', Times, serif;
  }
  .hideBtn{
      display: none;
  }
  #hideDate {
      display: none;
  }
  #divToPrint,
  #divToPrint * {
    visibility: visible;
  }
  #divToPrint {
    position: absolute;
    left: 0;
    top: 0;
    zoom: 150%;
    font-size: 20px;
    page-break-inside: avoid;
  }
  .causeListHeading {
    page-break-after: always;
  }
  .causeListSecondHeading{
    page-break-after: avoid;
  }
  #hideVerifiedText{
    display: none !important;
    visibility: hidden !important;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/causeList/printCauseListWithReason.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;IAClB,4CAA4C;EAC9C;EACA;MACI,aAAa;EACjB;EACA;MACI,aAAa;EACjB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;;AAEF","sourcesContent":["@media print {\n  body * {\n    visibility: hidden;\n    font-family: 'Times New Roman', Times, serif;\n  }\n  .hideBtn{\n      display: none;\n  }\n  #hideDate {\n      display: none;\n  }\n  #divToPrint,\n  #divToPrint * {\n    visibility: visible;\n  }\n  #divToPrint {\n    position: absolute;\n    left: 0;\n    top: 0;\n    zoom: 150%;\n    font-size: 20px;\n    page-break-inside: avoid;\n  }\n  .causeListHeading {\n    page-break-after: always;\n  }\n  .causeListSecondHeading{\n    page-break-after: avoid;\n  }\n  #hideVerifiedText{\n    display: none !important;\n    visibility: hidden !important;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
